import Timing, { TimingProps } from "@/Components/Order/Timing";
import useTime from "@/shared/hooks/useTime";
import useTimeElapsed from "@/shared/hooks/useTimeElapsed";

export interface ScreenOrderTimingProps extends TimingProps {
  date: string | undefined;
}

const ScreenOrderTiming = ({ date, ...props }: ScreenOrderTimingProps) => {
  if (!date) return null;
  const diff = useTimeElapsed(date);
  const time = useTime(diff);
  return <Timing bg="text" time={time} {...props} />;
};

export default ScreenOrderTiming;
